//import { useEffect } from 'react';

import { SOCKET_EVENTS, SOCKET_METHODS, SOCKET_TYPES } from '@/entities/SocketService';
import { IMarketPair } from '@/features/market/types';
import useSocket from '@/hooks/useSocket';
import { useChainId, useDappChainConfig } from '@/hooks/web3/useChain';
import { KlineInterval } from '@/types/chart';
import { useDebounceEffect } from 'ahooks';
import { useTradingViewStore } from '../store';
//import { defaultResolutionString } from '../constants';

type EventKlineData = {
  chainId: number;
  instrument: string;
  expiry: number;
  interval: KlineInterval;
  open: number;
  high: number;
  low: number;
  close: number;
  baseVolume: number;
  quoteVolume: number;
  volumeUSD: number;
  timestamp: number;
  startTime: number;
  endTime: number;
};

export const useTradingViewBarsUpdate = (currentPair: IMarketPair | undefined): void => {
  const { spotKlineInterval, datafeed } = useTradingViewStore();
  const { socket } = useSocket();
  const chainId = useChainId();
  const dappChainConfig = useDappChainConfig(chainId);

  useDebounceEffect(
    () => {
      if (!socket || !chainId || !currentPair?.instrumentAddr || !spotKlineInterval) return;

      const instrumentAddr = currentPair?.instrumentAddr;

      const param = {
        chainId: chainId,
        instrument: instrumentAddr,
        expiry: currentPair?.expiry,
        interval: spotKlineInterval,
        type: SOCKET_TYPES.KLINE,
      };

      const subscribeId = Date.now();
      socket.emit({
        id: subscribeId,
        method: SOCKET_METHODS.SUBSCRIBE,
        params: param,
      });

      socket.on(SOCKET_EVENTS.KLINE_CHANGED, (data) => {
        console.record('event', SOCKET_EVENTS.KLINE_CHANGED, data);
        const newTick: EventKlineData = data;
        if (datafeed) {
          datafeed?.updateBar({
            time: newTick.timestamp * 1000,
            open: newTick.open,
            high: newTick.high,
            low: newTick.low,
            close: newTick.close,
            volume: dappChainConfig?.futures?.isHideTradingViewVolume ? undefined : newTick.baseVolume,
          });
        }
      });

      return () => {
        socket.off(SOCKET_EVENTS.KLINE_CHANGED);
        socket.emit({ id: subscribeId, method: SOCKET_METHODS.UNSUBSCRIBE, params: param });
      };
    },
    [chainId, currentPair?.instrumentAddr, datafeed, socket, spotKlineInterval, dappChainConfig],
    {
      wait: 200,
    },
  );
};
